import React, { useState } from 'react';
import BackVideo from '../../components/BackVideo';

import SideLines from '../../components/Svg/side-lines';
import TopLines from '../../components/Svg/top-lines';
import Popup from '../../components/Popup';
import PopupVideo from '../../components/PopupVideo';
import Cart from '../../components/Cart/cart';
import {CSSTransition, TransitionGroup} from 'react-transition-group';

export default ({children, video, title, bg, popup, popupCloseHandler, ...props}) => {
    const { classSfx: popupType, opened: popupOpened, data: popupData } = popup;
    const [ popupVideoOpened, setPopupVideoOpened ] = useState(false);

    return (
        <>
            <section className = { `page-section${popupOpened ? ' in-blur' : ''}` }>
                <div className = 'hud hud-video-player'>
                    <div className = 'hud__container-decor'>
                        <div className = 'hud__bg'>
                            <div
                                className = 'hud__bg__video'
                                style = {
                                    bg ? {
                                        background: 'url(' + bg + ')',
                                    } : null
                                }
                            >
                                {video && (
                                    <BackVideo video = { video } />
                                )}
                            </div>
                            <div className = 'hud__bg__decor-top'/>
                            <div className = 'hud__bg__decor-bottom'/>
                        </div>

                        <div
                            className = 'hud__header'
                            style = {{height: '70px'}}>
                            <div className = 'hud__header__decor__container'>
                                <div className = 'hud__header__decor__row-1 hud__header__decor__row-center'>
                                    <div className = 'hud__header__decor__item'>
                                        <TopLines />
                                    </div>
                                </div>
                                <div className = 'hud__header__decor__row-2 hud__header__decor__row-space-between'>
                                    <div className = 'hud__header__decor__item'>
                                        <SideLines />
                                    </div>
                                    <div className = 'hud__header__decor__item hud__header__decor__item-reverse'>
                                        <SideLines />
                                    </div>
                                </div>
                            </div>
                            {title && <div className = 'hud__header__title'>{title}</div>}
                        </div>

                        <div
                            className = 'hud__footer'
                            style = {{height: '50px'}}>
                            <div className = 'hud__footer__decor__container'>
                                <div className = 'hud__footer__decor__row-1 hud__footer__decor__row-center'>
                                    <div className = 'hud__footer__decor__item'>
                                        <TopLines />
                                    </div>
                                </div>

                                <div className = 'hud__footer__decor__row-2 hud__footer__decor__row-space-between'>
                                    <div className = 'hud__footer__decor__item'>
                                        <SideLines />
                                    </div>

                                    <div className = 'hud__footer__decor__item hud__footer__decor__item-reverse'>
                                        <SideLines />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {children}
                </div>
            </section>

            <TransitionGroup>
                { popupOpened && (
                    <CSSTransition
                        classNames = 'fade'
                    >
                        <Popup
                            opened
                            closeHandler = { popupCloseHandler }
                            contentClassSfx = { `${popupType}-item` }
                            showCloseButton = { popupType === 'project' }
                        >
                            <Cart
                                cart = { popupData }
                                closeHandler = { popupCloseHandler }
                                playHandler = { () => setPopupVideoOpened(true) }
                            />
                        </Popup>
                    </CSSTransition>
                ) }
    
                <TransitionGroup>
                    { popupOpened && popupVideoOpened === true ? (
                        <CSSTransition
                            classNames = 'fade'
                        >
                            <PopupVideo
                                video={popupData.video}
                                closeHandler={() => setPopupVideoOpened(false)}
                            />
                        </CSSTransition>
                    ) : null }
                </TransitionGroup>
            </TransitionGroup>
        </>
    );
};
